const visible = function (el, binding) {
  el.style.visibility = binding.value ? "visible" : "hidden";
  el.style.opacity = binding.value ? "1" : "0";
};

export default visible;
